var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-text-message"},[_c('PreviewAvatar'),_c('div',{staticClass:"text-bubble-container"},[_c('div',{staticClass:"text-bubble"},[_c('p',{staticClass:"text-message"},[_vm._v(_vm._s(_vm.text))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }